import {
  DocumentApiInterface as ProDocumentApiInterface,
  Document as ProDocument,
  RemoveFilesFromDocumentBody,
} from "@syadem/kairos-pro-js";
import { DocumentApiInterface as TeamDocumentApiInterface, Document as TeamDocument } from "@syadem/kairos-team-js";
import { AppStore } from "../store";
import { Service } from "./service";
import { ActionResult } from "../actionResult";

interface Payload {
  healthRecordId: string;
  documentId: string;
  organizationId: string | null;
  teamId: string | null;
  fileIds: string[];
}

export class RemoveDocumentFilesService implements Service<Payload, ProDocument | TeamDocument> {
  constructor(
    private readonly proDocumentApi: ProDocumentApiInterface,
    private readonly teamDocumentApi: TeamDocumentApiInterface,
    private readonly store: AppStore,
  ) { }

  async call({
    healthRecordId,
    documentId,
    organizationId,
    teamId,
    fileIds,
  }: Payload): Promise<ActionResult<ProDocument | TeamDocument>> {
    let apiDocument: ProDocument | TeamDocument;

    const body: RemoveFilesFromDocumentBody = {
      fileIds,
    };

    if (organizationId && teamId) {
      apiDocument = await this.teamDocumentApi.removeFilesFromDocument(
        organizationId,
        teamId,
        healthRecordId,
        documentId,
        body,
      );
    } else {
      apiDocument = await this.proDocumentApi.removeFilesFromDocument(
        healthRecordId,
        documentId,
        body,
      );
    }

    this.updateDocumentInStore(healthRecordId, apiDocument);

    return {
      type: "success",
      value: apiDocument,
    };
  }

  private updateDocumentInStore(healthRecordId: string, document: ProDocument | TeamDocument) {
    this.store.setState((state) => {
      if (state.healthRecords && state.healthRecords[healthRecordId]) {
        const documents = state.healthRecords[healthRecordId].documents.map((doc) =>
          doc.id === document.id ? document : doc,
        );

        return {
          healthRecords: {
            ...state.healthRecords,
            [healthRecordId]: {
              ...state.healthRecords[healthRecordId],
              documents,
            },
          },
        };
      }
      return state;
    });
  }
} 